module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    attrs: {
      "placement": "top-right",
      "duration": "2000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.$set(_vm.error, "show", $$v)
      },
      expression: "error.show"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Error:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "signup_errormsg"
    }
  }, [_vm._v(_vm._s(_vm.error.message))])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), _c('h2', [_vm._v("\n                                Welcome to TONE.\n                                "), _c('br'), _vm._v(" "), (_vm.getTrialDays > 1) ? _c('span', [_vm._v("Your trial period will expire in " + _vm._s(_vm.getTrialDays) + " days.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays === 0) ? _c('span', [_vm._v("Your trial is expiring today.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays === 1) ? _c('span', [_vm._v("Your trial is expiring tomorrow.")]) : _vm._e(), _vm._v(" "), (_vm.getTrialDays < 0) ? _c('span', [_vm._v("Your trial period has expired.")]) : _vm._e(), _vm._v("\n                                 But don't worry - you can keep enjoying TONE by becoming a member!\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "left-content"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true
    }
  }, [_c('panel', {
    staticClass: "text-left",
    attrs: {
      "is-open": true
    }
  }, [_c('div', {
    staticClass: "create-account"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('form', {
    attrs: {
      "action": "/charge",
      "method": "post",
      "id": "payment-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPaymentSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Choose your membership plan:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "checkboxholder"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Two Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$8.99 "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.twoYearPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "2yearplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.twoYearPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.twoYearPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.twoYearPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.twoYearPlan.amount) + " billed once")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio popular"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("One Year Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$9.50 "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.annualPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "annualplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.annualPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.annualPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.annualPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("$" + _vm._s(_vm.annualPlan.amount) + " billed annually")])])])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Monthly Plan")]), _vm._v(" "), _c('span', {
    staticClass: "plan-price"
  }, [_vm._v("$" + _vm._s(_vm.defaultPlan.amount) + " "), _c('span', {
    staticClass: "permonth"
  }, [_vm._v("per month")])]), _vm._v(" "), (_vm.defaultPlan) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "type": "radio",
      "id": "monthlyplan",
      "name": "planselection"
    },
    domProps: {
      "value": _vm.defaultPlan.packageId,
      "checked": _vm._q(_vm.packageId, _vm.defaultPlan.packageId)
    },
    on: {
      "change": function($event) {
        _vm.packageId = _vm.defaultPlan.packageId
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "footertext"
  }, [_vm._v("billed monthly")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "codediv"
  }, [_c('div', {
    staticClass: "radiowrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gateway),
      expression: "gateway"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "CC",
      "name": "paymentMethod"
    },
    domProps: {
      "checked": _vm._q(_vm.gateway, "CC")
    },
    on: {
      "change": function($event) {
        _vm.gateway = "CC"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Credit Card")])]), _vm._v(" "), (_vm.gateway === 'CC') ? _c('bs-input', {
    staticClass: "form-input",
    attrs: {
      "id": "paymentMethod_cardHolder",
      "pattern": /^[A-Za-z ]+$/,
      "type": "text",
      "error": "Card Holder Name (no digits allowed)",
      "placeholder": "Card Holder Name",
      "required": "",
      "name": "cardholdername",
      "icon": ""
    },
    model: {
      value: (_vm.userObject.cardHolderName),
      callback: function($$v) {
        _vm.$set(_vm.userObject, "cardHolderName", $$v)
      },
      expression: "userObject.cardHolderName"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.gateway === 'CC') ? _c('div', {
    staticClass: "stripeholder"
  }, [(_vm.gateway === 'CC') ? _c('i', {
    staticClass: "fa fa-lock overlapstripe"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field",
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), (_vm.stripeErrorMessage) ? _c('div', {
    staticStyle: {
      "color": "#a94442",
      "margin": "2px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.stripeErrorMessage))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gateway === 'paypal') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "text-center margin-top-10 margin-bottom-10",
    attrs: {
      "id": "paypal-button"
    }
  })]), _vm._v(" "), (_vm.userPayments.paymentMethodNonce) ? _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left success"
  }, [_c('p', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Payment successfully authorized")])])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('checkbox', {
    staticClass: "terms-and-condition",
    attrs: {
      "value": "isChecked",
      "type": "primary"
    },
    model: {
      value: (_vm.isChecked),
      callback: function($$v) {
        _vm.isChecked = $$v
      },
      expression: "isChecked"
    }
  }, [_vm._v("\n                                                         I agree to "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "type": "submit",
      "id": "signup_button",
      "disabled": !_vm.isChecked || _vm.spinner,
      "name": "completesignupbutton"
    }
  }, [_vm._v("\n                                                        Become a Member\n                                                        "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])])])])])], 1)], 1)]), _vm._v(" "), _vm._m(0)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "hidemobile"
  }, [_c('h2', [_vm._v("Your Plan")]), _c('p', [_vm._v("What You Get")])]), _vm._v(" "), _c('div', {
    staticClass: "showmobile"
  }, [_c('h2', [_vm._v("What You Get")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('li', [_vm._v("Personalized bite-sized expert\n                                            videos will inspire you and set a positive\n                                            TONE to your day")]), _vm._v(" "), _c('li', {
    staticClass: "hidemobile"
  }, [_vm._v("A little dose of humor, and a pinch\n                                            of inspiration each time you log on.")]), _vm._v(" "), _c('li', [_vm._v("Reserve your spot for TONE Live...\n                                            Exclusive live streaming events with our\n                                            credentialed experts.")]), _vm._v(" "), _c('li', [_vm._v("Tune in to TONE Talks...our moderated\n                                            discussions every Tuesday and Thursday night\n                                            where we share advice within our community\n                                            of women helping women!")]), _vm._v(" "), _c('li', [_vm._v("And did we mention you will be helping out a\n                                            charity every time you use the site?")]), _vm._v(" "), _c('li', [_vm._v("Look out for TONE Teasers... customized emails with videos selected just for you!")])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-593730aa", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593730aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/TrialExpiry.vue